import { GenericTable } from "@shared/components/GenericTable";
import { cn } from "@shared/lib/utils";
import { TableColumn } from "@shared/types/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shared/ui/select";
import dayjs from "dayjs";
import React from "react";
import { Badge } from "@shared/ui/badge";

interface MeterData {
  id: string;
  meterNumber: string;
  deviceNo: string;
  productCode: string;
  previousReading: number;
  previousReadingDate: string;
  previousReadingMeterStatusDisplay: string;
  currentReading: number;
  currentReadingDate: string;
  currentReadingMeterStatus: string;
}

interface ConsumptionTableProps {
  utilityType: string;
  meterUpdates: { [meterId: string]: any };
  handleMeterChange: (meterId: string, field: string, value: any) => void;
  getMeterValue: (meterId: string, field: string, originalValue: any) => any;
  invoiceStartDate?: string;
  invoiceEndDate?: string;
}

const ConsumptionTable= ({data}) => {

  const meterColumns: TableColumn[] = [
    {
      key: "meterInfo",
      header: "Resource ID/Serial No",
      type: "custom",
      render: (_, row) => `${row.meterNumber}/${row.deviceNumber}`,
    },
    {
      key: "utilityService",
      header: "Utility Service",
      type: "custom",
      render: (value) => value ? <Badge>{value}</Badge> : "NA",
    },
    {
      key: "previousReading",
      header: "Last Reading",
      type: "text",
      render: (value) => value ?? "NA",
    },
    {
      key: "previousStatus",
      header: "Prev Status",
      type: "text",
      render: (value) => value ?? "NA",
    },
    {
      key: "previousReadingDate",
      header: "Last Date",
      type: "text",
      render: (value) => value ?? "NA",
    },
    {
      key: "currentReading",
      header: "Current Reading",
    },
    {
      key: "currentReadingMeterStatus",
      header: "Curr Status",
    },
    {
      key: "currentReadingDate",
      header: "Current Date",
    },
    {
      key: "totalConsumption",
      header: "Consumption",
    },
  ];

  return (
    <div className="space-y-4">
        {/* <Select>
  <SelectTrigger>
    <SelectValue placeholder="Select utility" />
  </SelectTrigger>

  <SelectContent>
    <SelectItem value="water">Water</SelectItem>
    <SelectItem value="gas">Gas</SelectItem>
    <SelectItem value="electricity">Electricity</SelectItem>
  </SelectContent>
</Select> */}
      <GenericTable
        data={data ?? []}
        columns={meterColumns}
        loading={false}
        rowKey="id"
        emptyMessage={`No data available`}
      />
    </div>
  );
};

export default ConsumptionTable;